$('.portfolio--item-link').on('click',function(e) {

  e.preventDefault();
  var href     = $(this).attr('href');
  var status   = $('#portfolio-filter--status').val();
  var strategy = $('#portfolio-filter--strategy').val();
  var query    = '';

  if ( status || strategy ) {

    query    = '?';

    if ( status ) {
      query += 'status=' +status;
    }

    if ( strategy ) {
      query += '&strategy=' +strategy;
    }

    href = href + query;

  }

  if (history.pushState) {
    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + query;
    window.history.pushState({path:newurl},'',newurl);
  }

  window.location.href = href;

});

if ( $('.portfolio--dropdown').length > 0 ) {

  $('.portfolio--dropdown').on('change', function(e) {
    e.preventDefault();
    filterPortfolio();
  });

}

function filterPortfolio() {

  $('#portfolio--search-input').val("");

  var classesArray = [];
  var portfolios   = $('.portfolio--item');

  $('.portfolio--dropdown').each(function(){

    var selectClass = $(this).val();

    if (selectClass) {
      classesArray.push(selectClass);
    }

  });

  if (classesArray.length > 0) {

    portfolios.each(function() {

      var shouldHide = false;
      var portItem  = $(this);

      $.each(classesArray, function(i,val) {

        if ( !portItem.hasClass(val) ) {
          shouldHide = true;
        }

      });

      if (shouldHide) {
        $(this).addClass('is-hiding');
      } else {
        $(this).removeClass('is-hiding');
      };

    });

  } else {

    $('.portfolio--item').removeClass('is-hiding');

  }

  portfolios.addClass('over');

}


$('.portfolio--item-link').on('click',function(e) {

  e.preventDefault();
  $( $(this).attr('href') ).addClass('is-open');

});

$('.portfolio-modal-close').on('click',function(e) {

  e.preventDefault();
  $( $(this).attr('href') ).removeClass('is-open');

});

// $('.portfolio-modal:not(.portfolio-modal-wrap)').on('click',function(e) {

//   e.preventDefault();
//   let href = $(this).find('.portfolio-modal-close');
//   $( href.attr('href') ).removeClass('is-open');

// });

